import { render, staticRenderFns } from "./EventInfoPreview.vue?vue&type=template&id=6128a4e8&scoped=true"
import script from "./EventInfoPreview.vue?vue&type=script&setup=true&lang=ts"
export * from "./EventInfoPreview.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./EventInfoPreview.vue?vue&type=style&index=0&id=6128a4e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6128a4e8",
  null
  
)

export default component.exports